// A recording made on the create page, waiting for its character to exist.
// On web the character row appears only once its picture has been drawn, so
// the character page uploads the recording as soon as it loads the character.
// In memory only: a reload loses it, and the family can record again from the
// character page's Voice button (free until a recording has landed).
export const pendingVoiceUploads = new Map(); // characterId -> File
